import { render, staticRenderFns } from "./ProgressAttivita.vue?vue&type=template&id=52334e6d&"
import script from "./ProgressAttivita.vue?vue&type=script&lang=js&"
export * from "./ProgressAttivita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports